export interface IExonantialBackOffOptions {
  isFirstAttepmtDelayed: boolean
  maximumDelay: number
  numberOfAttempts: number
  retry: (e: any, attemptNumber: number) => boolean | Promise<boolean>
  startingDelay: number
  exponantialTime: number
}

const defaultOptions: IExonantialBackOffOptions = {
  isFirstAttepmtDelayed: false,
  maximumDelay: Infinity,
  numberOfAttempts: 10,
  retry: () => true,
  startingDelay: 100,
  exponantialTime: 2,
}

export const getOptionsSanitized = (
  options: Partial<IExonantialBackOffOptions>,
) => {
  const optionsSanitized: IExonantialBackOffOptions = {
    ...defaultOptions,
    ...options,
  }

  if (optionsSanitized.numberOfAttempts < 1) {
    optionsSanitized.numberOfAttempts = 1
  }

  return optionsSanitized
}
